import { getLocaleFromPathname, isSupportedLocale } from 'i18n/util/localeUrl'
import { reportClientMessage } from 'services/errorReportingService'

export function reportInvalidUrlLocaleIfPresent(pathname: string): void {
  const locale = getLocaleFromPathname(pathname)
  if (locale && !isSupportedLocale(locale)) {
    reportClientMessage(
      'url_locale_invalid',
      { pathname, locale },
      'warning',
      { domain: 'i18n', surface: 'url_locale' },
    )
  }
}
